var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1236_13817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6412 39C48.8912 39 50.8712 37.77 51.8912 35.91L62.6312 16.44C63.7412 14.46 62.3012 12 60.0212 12H15.6212L12.8012 6H2.99121V12H8.99121L19.7912 34.77L15.7412 42.09C13.5512 46.11 16.4312 51 20.9912 51H56.9912V45H20.9912L24.2912 39H46.6412ZM18.4712 18H54.9212L46.6412 33H25.5812L18.4712 18ZM20.9912 54C17.6912 54 15.0212 56.7 15.0212 60C15.0212 63.3 17.6912 66 20.9912 66C24.2912 66 26.9912 63.3 26.9912 60C26.9912 56.7 24.2912 54 20.9912 54ZM50.9912 54C47.6912 54 45.0212 56.7 45.0212 60C45.0212 63.3 47.6912 66 50.9912 66C54.2912 66 56.9912 63.3 56.9912 60C56.9912 56.7 54.2912 54 50.9912 54Z",
    fill: "#677D9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1236_13817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.ec60c80c.svg";
export { ForwardRef as ReactComponent };